import { render, staticRenderFns } from "./HMSimpleActionCard.vue?vue&type=template&id=c08ac47a&scoped=true&"
import script from "./HMSimpleActionCard.vue?vue&type=script&lang=ts&"
export * from "./HMSimpleActionCard.vue?vue&type=script&lang=ts&"
import style0 from "./HMSimpleActionCard.vue?vue&type=style&index=0&id=c08ac47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08ac47a",
  null
  
)

export default component.exports